module.exports = __webpack_public_path__ + "static/tfk-tou-780e63b42b1d6eaf02b2540e1b122864.pdf";